import ResponsiveImage from "../ResponsiveImage";

/**
 * Image gallery section used on Service, City-Service, Panne and Panne-Geo pages.
 * Renders 3 thematic images in a responsive grid with proper alt text for SEO.
 */
export default function ImageGallery({ images, title, subtitle }) {
    if (!images || images.length === 0) return null;
    return (
        <section className="max-w-7xl mx-auto px-5 lg:px-10 py-12" data-testid="image-gallery">
            {(title || subtitle) && (
                <div className="max-w-3xl mb-8">
                    {title && (<>
                        <div className="divider-amber mb-5" />
                        <h2 className="heading text-2xl lg:text-3xl font-extrabold text-[var(--navy)]">{title}</h2>
                    </>)}
                    {subtitle && <p className="mt-3 text-[var(--ink-soft)]">{subtitle}</p>}
                </div>
            )}
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {images.map((img, i) => (
                    <figure key={img.slug + i} className="rounded-2xl overflow-hidden border border-[var(--line)] bg-white" data-testid={`gallery-img-${i}`}>
                        <div className="aspect-[4/3] overflow-hidden">
                            <ResponsiveImage
                                slug={img.slug}
                                alt={img.alt}
                                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                            />
                        </div>
                        {img.caption && (
                            <figcaption className="px-4 py-3 text-xs text-[var(--ink-soft)] border-t border-[var(--line)]">
                                {img.caption}
                            </figcaption>
                        )}
                    </figure>
                ))}
            </div>
        </section>
    );
}
